import { DELEGATE_FETCHED, CURRENT_DELEGATE } from "../types";

const initialState = {
  delegateData: [] as any,
  delegate:[] as any
};

const delegation = (state = initialState, action: any) => {
  switch (action.type) {
    case DELEGATE_FETCHED:
      return {
        ...state,
        delegateData: action.delegateData,
      };
    case CURRENT_DELEGATE:
      return {
        ...state,
        delegate: action.delegate,
      };
    default:
      return state;
  }
};

export default delegation;



